import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { DamserviceService } from "../dam/damservice.service";
import { Title, Meta } from '@angular/platform-browser';
import { AuthService } from "angularx-social-login";
import { OrganisationService } from "../create-organisation/organisation.service";
import { AlertService } from "../components/alert/alert.service";
import { UploadFilesService } from 'src/app/services/upload-files.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { FormBuilder, Validators } from '@angular/forms';
import { InboxservicesService } from "../inboxarea/inboxservices.service";
import { environment } from '../../environments/environment';
import { SubscriptionService } from "../subscription/subscription.service";
import { WindowRefService } from '../services/window-ref.service';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { GoogleAnalyticsService } from '../google-analytics.service';
import AOS from 'aos';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  currentUserData = this.authenticationService.currentUserValue;
  submitted: Boolean = false;
  profileForm = this.fb.group({
    firstName: [this.currentUserData.firstName, Validators.required],
    lastName: this.currentUserData.lastName,
  });

  title = 'Settings | Workspace | Crafttor';

  checkedId = -1;
  count: number = 0;
  fileText: string;
  currentUser: User;
  mobileView: boolean = false;
  boards = [];
  imagesExtension: [];
  workspaces = [];
  imagesList = [];
  searchText: string = '';
  searchTerms: string[] = [];
  edittedWorkspaceName: string = '';
  edittedWorkspaceFirstName: string = '';
  edittedWorkspaceLastName: string = '';
  edittedWorkspaceEmail: string = '';
  searchData: string = '';
  currentIllus: any;
  currentBoard: any;
  boardHeading: string = '';
  userPic: any;
  workspaceId: any;
  workspaceName: string;
  userRole: string;
  boardId: any;
  totalSpace: any;
  availableSpace: any;
  utilisedSpace: any;
  totalSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  totalAllowedInvites: any;
  totalInvited: any;
  totalAdminInvited: any;
  totalWorkspaceCreated: any;
  allowedAdmin: any;
  allowedWorkspace: any;
  workspaceCountAllowed: any;
  consumedSpaceAllowed: any;
  planName: String;
  ownerEmail: String;
  ownerName: String;
  shareStyle = "none";
  deleteWorkspaceStyle = "none";
  deleteBoardStyle = "none";
  deleteProcessStyle = "none";
  deletWorkspaceProcessStyle = "none";
  deleteBoardId: any;
  deleteBoardName: string;
  svgCheck: boolean = false;
  pngCheck: boolean = false;
  jpgCheck: boolean = false;
  showTopRightLoader: boolean = false;
  showLoaderBoardsList: boolean = false;
  showAllAssetsSettings: boolean = false;
  showCouponTab: boolean = false;
  startApplyCouponLoader: boolean = false;
  couponCount: any;
  couponFrom: string;
  coupon2Value: string = '';
  coupon3Value: string = '';
  addTagText: string = '';
  addedTag:string;
  addedTagList: Array<{tags: string}> = [];
  plusButton: boolean = true;
  tagFieldArea: boolean = false;
  changeColor= [false, false, false];
  imagesIdList: Array<{id: any, title: string}> = [];
  imagesIds: Array<{id: any}> = [];
  moveFromSearch: boolean = false;
  moveBoards = [];
  moveBoardId: any;
  searchedBoards = [];
  moveImagesStyle = "none";
  showSearchBoardList: boolean = false;
  showSearchBoardOlderList: boolean = true;
  boardSearchKeyword: string;
  asssetsIdsList = [];
  imageSelected:boolean = false;
  searchTextSet: any;
  downloadDelete:boolean = false;
  emailUpdates: boolean = true;
  showAddSeatsDialog: boolean = false;
  showMoreAdminsDialog: boolean = false;
  paymentProcessStyle = "none";
  paymentSuccessStyle = "none";
  adminPaymentSuccessStyle = "none";
  paymentRazorProcessStyle = "none";
  showSuccesssFullMessage: boolean = false;
  isAllWorkspaceSelected: boolean = false;
  isSelectEnabled: boolean = true;
  isBoardDisabled: boolean = false;
  isAllBoardSelected: boolean = false;
  allBoardChecked: boolean = false;
  pluginDataSaved: boolean = false;
  showAppliedBoard: boolean = false;
  pluginMsg: string;
  pluginBoardId: any;
  rangeValue: any = '100';
  selectedBoardsList: [];

  showUsersListDialog: boolean = false;
  showUsersListReplyDialog: boolean = false;
  userSelectedForTag: boolean = false;
  userSelectedForReplyTag: boolean = false;
  selectedUserIdForTag: any;
  selectedUserNameForTag: any;
  usersList = [];

  showCouponTwoField: boolean = true;
  showCouponThreeField: boolean = false;

  fileInfos: [];
  totalIllusCount: any;
  hideDialogSection: boolean = true;
  boardname: string = '';
  editBoardId: any;
  addUserCount: any = 0;
  addAdminUserCount: any = 0;
  addAdminsCount: any = 0;
  totalPriceFixed: any = 0;
  totalAdminPriceFixed: any = 0;
  shareableLink: string;
  shareImageLink: any;
  renameImageLink: any;
  editTagsImageLink: any;
  editTagsImageFormats: any;
  editTagsName: any;
  editTagsList: string[] = [];
  assetEditTagsStyle = "none";
  showEditTagsLoader: boolean = false;
  editTagsError: any;
  shareLinkStyle = "none";
  isShowShareLinkGenerated: boolean = true;
  isHideShareLinkGenerated: boolean = false;
  optionDisabled: boolean = false;
  showLeaveLoader: boolean = false;
  showDeleteLeaveLoader: boolean = false;
  showWorkspaceLeaveLoader: boolean;
  showChatLoader: boolean = false;
  showProfileUpdateLoader: boolean = false;

  selectedFiles: FileList;
  progressInfos = [];
  message = '';

  settingsSection: boolean = true;
  searchImageslistSection: boolean = false;
  imageHeading: string = '';
  favImageHeading: string = '';
  imageNameEdit: string = '';
  favImageNameEdit: string = '';
  showEditImageName: boolean = false;
  hideEditImageName: boolean = true;
  showEditFavImageName: boolean = false;
  hideEditFavImageName: boolean = true;

  boardRenameStyle = "none";
  boardCurrentName: any;
  boardNewName: any;
  editNameBoardId: any;

  notifications = [];
  date: string;
  dateValue: [];
  suggestedTags = [];
  notificationMsg: string;
  showLoader: boolean = false;
  boardIdsList = [];
  sendSuccessful: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;
  successfullMessage: string;
  planId: any;

  planValidityYear: any;
  planValidityMonth: any;
  planValidityDate: any;
  planValidityDaysLeft: any;
  showMaxSeatsReached: boolean = false;
  showMaxAdminsReached: boolean = false;
  showSeatsErrorText: string;
  showAdminsErrorText: string;

  private month_membership: any = [];
  private year_membership: any = [];
  @ViewChild('paymentSuccess') paymentSuccess;
  paymentSuccessModal: any;
  address: string = '128 santa rosa';
  city: string = 'San Francisco';
  state: string = 'CA';
  country: string = 'US';
  postcode: string = '94014';
  newAmount: string;
  totalUsers: string;
  isCustomPlan: boolean = false;
  strikeCheckout:any = null;

  orderId: any;
  totalRazorAmount: any;
  userRazorPayName: string;
  razorPayKey: string;
  public isIndia: boolean = true;
  public isIndiaAdmin: boolean = true;
  radioIndia: boolean = true;
  radioIndiaAdmin: boolean = true
  radioOthers: boolean = false;
  radioOthersAdmin: boolean = false;
  showLinkCopied: boolean = false;
  showSearchNextIcon: boolean = true;
  showSearchPreviosIcon: boolean = true;
  currentSearchIllusPosition: any;

  razorpaySeatsPaymentId: string;
  razorpaySeatsOrderId: string;
  razorpaySeatsSignature: string;

  razorpayPaymentId: string;
  razorpayOrderId: string;
  razorpaySignature: string;

  imageDownloadFormat: any;
  imageDownloadShowFormat: any;
  showDownloadLoader: boolean = false;
  showMainDownloadLoader: boolean = false;
  showEditWorkspaceNameLoader: boolean = false;
  showDownloadDialog: boolean = false;
  public selectedFormatIndex;
  imageFormats = [];

  isShowLoadingStatus: boolean = false;
  isShowLoadingStatusDone: boolean = false;
  selectedVersion: any;
  uploadedFileName: string;
  uploadOptionsStyle = "none";
  uploadVersionStyle = "none";
  progressPecentage: any;
  public replaceAsset: boolean = true;
  showSmallImg: boolean = false;

  commentId: any;
  commentMsg: any;
  replyMsg: any;
  editComment: any;
  commentsList = [];
  noComments: any;
  openEditBox: boolean = false;
  public textArea: string = '';
  public replyArea: string = '';

  sharedToken: any;
  fromAssets: boolean = false;
  allowDownloads: any;
  showComments: any;
  allowComments: any;
  allowDownloadSelected: boolean = true;
  showCommentSelected: boolean = false;
  allowCommentingSelected: boolean = false;
  expiryLinkIn: any = "f";

  renameErrorMsg: string;
  assetRenameStyle = "none";
  assetCurrentId: any;
  assetCurrentName: any;
  assetBoardId: any;
  assetNewName: any;
  renameBoardId: any;
  showRenameLoader: boolean = false;

  public index;

  createPrivateSharedWorkspaceStyle = "none";
  createWorkspaceStyle = "none";
  isShowCreateWorkspaceError: boolean = false
  createWorkspaceErrorMessage: string;
  isShowCreateLoginWorkspaceError: boolean = false
  createWorkspaceLoginErrorMessage: string;

  creatwWorkspace = this.fb.group({
    message: ['', Validators.required],
  });

  commentForm = this.fb.group({
    comment: ['', Validators.required],
  });

  replyForm = this.fb.group({
    replyMessage: ['', Validators.required],
  });

  mainMsgForm = this.fb.group({
    mainmessage: ['', Validators.required],
  });

  tagsForm = this.fb.group({
    edittags: ['', Validators.required],
  });

  @ViewChild('imgSearchModal') imgSearchModal;
  @ViewChild('shareModal') shareModal;
  @ViewChildren("checkboxes") checkboxes;

  public selectedIndex;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private damService: DamserviceService,
    private authService: AuthService,
    private titleService: Title,
    private metaTagService: Meta,
    private organisationService: OrganisationService,
    private alert: AlertService,
    private uploadService: UploadFilesService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private inboxService: InboxservicesService,
    private subscriptionService: SubscriptionService,
    private winRef: WindowRefService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'The owner of the workspace can change the workspace name or can delete their workspace anytime and it cannot be recovered again.'},
      { name: 'keywords', content: 'delete workspace, trash workspace, workspace, settings workspace, change workspace name' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    AOS.init();

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });

    if(this.currentUser) {
      this.getWorkspaceDetails();
      this.getUserPic();
      this.getFavImagesList();
    } else {
      this.router.navigate(['/login']);
    }

    // this.suggestedTags.push("3D");
    // this.suggestedTags.push("illustration");
    // this.suggestedTags.push("vector");
    // this.suggestedTags.push("woman");
    // this.suggestedTags.push("man");
    // this.suggestedTags.push("product");
    // this.suggestedTags.push("laptop");
    // this.suggestedTags.push("mobile");
    // this.listWorkspace();

    this.imageFormats.push("PNG");
    this.imageFormats.push("JPEG");
    // this.imageFormats.push("gif");
    // this.imageFormats.push("raw");
    this.imageFormats.push("TIFF");
    this.imageFormats.push("WEBP");

    this.searchTerms = [];
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.edittedWorkspaceName = details.workspaceName;
    this.getCurrentUserData(this.workspaceId);
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
          this.ownerListApi();
          }else{
            this.router.navigate(['/create-workspace']);
          }
        });
      }else{
        this.router.navigate(['/login']);
      }
  }

  getCurrentUserData(workspaceId: any) {
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
      this.edittedWorkspaceEmail = data.email;
      this.listWorkspace();
      this.getBoardsListing();
    },
    (error) => {
      if (this.currentUser) {
        if(error.status == 500){
          // this.router.navigate(['/maintenance']);
        } else {

        }
      } else {
        this.router.navigate(['/login']);
      }
  });
  }

  getBoardsListing() {
    this.showLoaderBoardsList = true;
    this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      this.boards = data;
      this.pluginBoardId = this.boards[0].id;
      this.showLoaderBoardsList = false;
    });
  }

  selectWorkspace(id: any, title: string, userRole: string){
    this.workspaceName = title;
    this.workspaceId = id;
    this.getCurrentUserData(this.workspaceId);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: id,
      workspaceName: title, userRole: userRole }));
    this.router.navigate(['/dam']);
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000
      this.consumedSpaceAllowed = data.current_dam_space/1000
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000
      this.totalAllowedInvites = data.allowed_seats;
      this.allowedAdmin = data.allowed_admin;
      this.totalInvited = data.total_invited+1;
      this.totalAdminInvited = data.total_admin_invited;
      this.totalWorkspaceCreated = data.total_workspace_created;
      this.allowedWorkspace = data.allowed_workspace;
      this.planId = data.plan_id;
      this.workspaceCountAllowed = data.allowed_workspace;
      this.couponCount = data.coupon_count;
      this.couponFrom = data.coupon_from;
      this.planValidity();
      if(this.planName != 'Free') {
        this.showAllAssetsSettings = true;
      } else if(this.planName == 'Free') {
        this.showAllAssetsSettings = false;
      }

      if(this.couponFrom == "appsumo" && this.couponCount > 0) {
        this.showCouponTab = true;
        if(this.couponCount == 1) {
          this.showCouponTwoField = true;
          this.showCouponThreeField = false;
        } else if(this.couponCount == 2) {
          this.showCouponTwoField = false;
          this.showCouponThreeField = true;
        } else if(this.couponCount == 3) {
          this.showCouponTwoField = false;
          this.showCouponThreeField = false;
        }
      }
    });
  }

  deleteWorkspaceApi(){
    // this.deleteWorkspaceStyle = "none";
    this.showWorkspaceLeaveLoader = true;
    // this.deletWorkspaceProcessStyle = "block";
    this.organisationService.deleteWorkspace(this.workspaceId).subscribe((data: any) => {
      this.deletWorkspaceProcessStyle = "none";
      this.showWorkspaceLeaveLoader = false;
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data[0].id,
            workspaceName: data[0].title, userRole: data[0].role }));
          this.router.navigate(['/dam']);
        }else{
          localStorage.clear();
          this.authenticationService.logout();
          this.authService.signOut();
          this.router.navigate(['/home']);
        }
      });
    },
    (error) => {
      this.showWorkspaceLeaveLoader = false;
      this.sendSuccessfulErrorMsg = true;
      this.sendSuccessfulErrorMessage = error.error.Message;
      this.hideSuccesfullFunctionErrorDelete();
   });
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  mainClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam']);
  }

  peopleClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/people']);
  }

  personalClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  newBoardClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/create-board']);
  }

  archiveClick() {
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['dam/trash']);
  }

  inboxClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['dam/inbox']);
  }

  showUpgradePlans(){
    window.scrollTo(0, 0);
    // this.selectedMembershipBuyNow = membership;
    if (this.currentUser) {
      this.googleAnalyticsService.event('upgrade_plan_settings_screen_click', 'upgrade_plan', this.currentUser.firstName +" "+this.currentUser.lastName);
      localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
        workspaceName: this.workspaceName, userRole: this.userRole }));
      this.router.navigate(['/dam/subscription']);
    }
  }

  deleteBoards(id: any, title: string){
    this.selectedIndex = -1;
    this.damService.archiveBoards(this.workspaceId, id).subscribe((data: any) => {
      this.searchImageslistSection = false;
      this.settingsSection = true;
      this.reStartListing();
    });
  }

  openDeleteStyleBoard(){
    this.deleteProcessStyle = "block";
  }

  closeDeleteStyleBoard() {
   this.showLeaveLoader = false;
   this.deleteProcessStyle = "none";
  }

  deleteBoard(){
    this.showDeleteLeaveLoader = true;
    this.selectedIndex = -1;
    // this.closeDeleteBoardShare();
    // this.openDeleteStyleBoard();
    this.damService.archiveBoards(this.workspaceId, this.deleteBoardId).subscribe((data: any) => {
      this.closeDeleteBoardShare();
      this.sendSuccessful = true;
      this.successfullMessage = this.deleteBoardName + " moved to trash";
      this.hideSuccesfullFunction();
      this.showDeleteLeaveLoader = false;
      this.searchImageslistSection = false;
      this.settingsSection = true;
      this.reStartListing();
    },
    (error) => {
      this.closeDeleteBoardShare();
      if(error.status == 403){
        this.showDeleteLeaveLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.Message;
        this.hideSuccesfullFunctionErrorDelete();
      } else if(error.status == 401){
        this.showDeleteLeaveLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.Message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showDeleteLeaveLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.Message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  deleteFullBoards(title: string){
    this.selectedIndex = -1;
    this.damService.archiveBoards(this.workspaceId, this.boardId).subscribe((data: any) => {
      this.searchImageslistSection = false;
      this.settingsSection = true;
      this.reStartListing();
    });
  }


  reStartListing(){
    this.showLoaderBoardsList = true;
    this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      this.boards = data;
      this.showLoaderBoardsList = false;
    });
  }

  // onSubmit() {
  //   if(this.searchText != '') {
  //     this.searchImages(this.searchText);
  //   }
  // }

  searchImages(searchText: string = ""){
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.changeColor = [];
    this.imageSelected = false;
    this.searchTextSet = searchText;
    this.damService.searchImages(this.workspaceId, searchText).subscribe((data: any) => {
      this.imagesList = data.image;
      this.searchData = this.searchText;
      this.settingsSection = false;
      this.searchImageslistSection = true;
    });
  }

  editBoardClickNew(boardTitle: string, boardId: any){
    localStorage.setItem('editBoardDetails', JSON.stringify({ boardId: boardId, boardTitle: boardTitle}));
    this.router.navigate(['/dam/edit-board']);
  }

  settingsClick(){
    this.searchTerms = [];
    this.titleService.setTitle("Settings | Workspace | Crafttor");
    this.selectedIndex = -1;
    this.searchText = '';
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.changeColor = [];
    this.imageSelected = false;
    this.searchImageslistSection = false;
    this.settingsSection = true;
  }

  boardlistClickNew(boardName: string, boardId: any){
    localStorage.setItem('boardDetails', JSON.stringify({ boardId: boardId, boardTitle: boardName}));
    this.router.navigate(['/dam/'+boardName]);
  }

  openImgSearchDialog(modal, currentImgPos: any, currentVersion: any,
    boardId: any, currentAssetId: any, imgName: string){
      this.suggestedTags = [];
      this.getSuggestedTags(boardId, currentAssetId);
      this.selectedVersion = currentVersion;
      this.imageHeading = imgName;
      this.favImageHeading = imgName;
      this.hideEditImageName = true;
      this.hideEditFavImageName = true;
      this.addTagText = '';
      this.plusButton = true;
      this.tagFieldArea = false;
      this.selectedFormatIndex = 0;
      this.imageDownloadShowFormat = "PNG";
      this.imageDownloadFormat = 'png';
      this.currentSearchIllusPosition = currentImgPos;
      if(currentImgPos == this.imagesList.length-1) {
        this.showSearchNextIcon = false;
        this.showSearchPreviosIcon = true;
      } else if(currentImgPos == 0){
        this.showSearchPreviosIcon = false;
        this.showSearchNextIcon = true;
      } else {
        this.showSearchPreviosIcon = true;
        this.showSearchNextIcon = true;
      }
      this.imgSearchModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-modal ' });
  }

  openShareDialog(modal){
      this.shareModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-share-input ' });
  }

  hideDialogClick(){
    if(this.hideDialogSection){
      this.hideDialogSection = false;
    }else{
      this.hideDialogSection = true;
    }
  }

  getInfo(currentImageId: any){
    // console.log("Akash Details for : : "+currentImageId);
  }

    downloadImage(currentImageId: any, titleImage: string, boardId: any): void {
      this.damService.downloadImages(this.workspaceId, boardId, currentImageId).subscribe((data: any) => {
        saveAs(data, titleImage)
      },
        (error: any) => {
          if (error.status === 403) {
            // this.openLimitModal(this.limitModal);

          }
          else {
            // this.alert.alert("Alert", "Limit reached! Please login to download", () => {
          }
        }
      );
    }

    editWorkspaceName(){
      this.showEditWorkspaceNameLoader = true;
      this.damService.editWorkspaceName(this.workspaceId, this.edittedWorkspaceName).subscribe((data: any) => {
        this.showEditWorkspaceNameLoader = false;
        this.sendSuccessful = true;
        this.successfullMessage = "Workspace name changed successfully!!";
        this.hideSuccesfullFunction();
        localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data.id,
          workspaceName: data.title, userRole: data.role }));
        var details = JSON.parse(localStorage.getItem('workspaceDetails'));
        this.workspaceId = details.workspaceId;
        this.workspaceName = details.workspaceName;
        this.edittedWorkspaceName = details.workspaceName;
        this.listWorkspace();
      });
    }

    newCrafttor(): void {
      this.openNewWorkspaceDialog();
    }

    openPopupShare(imgId: any) {
      this.fromAssets = true;
      this.shareStyle = "block";
      this.hitSharePopUpApi(imgId);
    }

    hitSharePopUpApi(imgId: any) {
      this.subscriptionService.hitShare(this.workspaceId, this.boardId, imgId, "").subscribe((data) => {
        this.shareableLink = data.link;
        this.sharedToken = data.token;
        this.hideContent();
      },(error: any) => {
        if(error.status == 400){
          this.hideContent();
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.hideContent();
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    openShareLinkStyle(imgId: any, imgLink: any, boardId: any) {
      this.fromAssets = true;
      this.shareImageLink = imgLink;
      this.hitShareAssetsApi(imgId, boardId);
    }

    hitShareAssetsApi(imgId: any, boardId: any) {
      this.subscriptionService.hitShare(this.workspaceId, boardId, imgId, "").subscribe((data) => {
        this.shareableLink = data.link;
        this.sharedToken = data.token;
        this.shareLinkStyle = "block";
        this.hideContent();
      },(error: any) => {
        if(error.status == 400){
          this.hideContent();
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.hideContent();
          this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    deleteSingleSearchDialogImage(imgId: any, boardId: any){
      // this.damService.deleteImages
      this.damService.archiveSingleImages(this.workspaceId, boardId, imgId).subscribe((data: any) => {
        this.searchArrayImages(this.searchText, this.searchTerms);
      },(error) => {
        if(error.status == 403){
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = "You are not allowed to delete this asset.";
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = "Something went wrong.";
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
    }

    closePopupShare() {
      this.imagesIds = [];
      this.fromAssets = false;
      this.shareStyle = "none";
    }

    openDeleteWorkspaceShare() {
      this.deleteWorkspaceStyle = "block";
    }

    closeDeleteWorkspaceShare() {
     this.deleteWorkspaceStyle = "none";
    }

    openDeleteBoardShare(boardId: any, boardName: string) {
      this.deleteBoardId = boardId;
      this.deleteBoardName = boardName;
      this.deleteBoardStyle = "block";
    }

    closeDeleteBoardShare() {
      this.showDeleteLeaveLoader = false;
     this.deleteBoardStyle = "none";
    }

   filterImages(boardId: any, searchText: string){
     this.damService.filterImage(this.workspaceId, boardId, searchText).subscribe((data: any) => {
       this.fileInfos = data['results'];
       this.totalIllusCount = data['results'].length;
     });
   }

   clearFilter(){
     this.svgCheck = false;
     this.pngCheck = false;
     this.jpgCheck = false;
     this.damService.filterImage(this.workspaceId, this.boardId, "").subscribe((data: any) => {
       this.fileInfos = data['results'];
       this.totalIllusCount = data['results'].length;
     });
   }

   showTagFieldData(){
     this.plusButton = false;
     this.tagFieldArea = true;
   }

   onSubmitTag(boardId: any){
     this.addTagsData(this.addTagText, boardId);
   }

   addTagsData(addTagText: string, boardId: any){
     this.addTagText = '';
     this.plusButton = false;
     this.tagFieldArea = true;
     this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
       addTagText).subscribe((data: any) => {
         this.addedTag = data.tag;
         this.addedTagList.push({tags: this.addedTag});
         this.searchArrayImages(this.searchText, this.searchTerms);
     });
   }

   onSubmitSuggestedTag(tag: any, boardId: any){
    this.addSuggestedTagsData(tag, boardId);
   }

  addSuggestedTagsData(addTagText: string, boardId: any){
    this.addTagText = '';
    this.plusButton = true;
    this.tagFieldArea = false;
    this.damService.addImageTags(this.workspaceId, boardId, this.currentIllus.id,
      addTagText).subscribe((data: any) => {
        this.addedTag = data.tag;
        this.addedTagList.push({tags: this.addedTag});
        this.searchArrayImages(this.searchText, this.searchTerms);
    });
  }

   deleteImageTags(title: string, i: any){
     this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
       this.currentIllus.tags.splice(i, 1);
       this.searchArrayImages(this.searchText, this.searchTerms);
     });
   }

   deleteImageTagsList(title: string, i: any){
     this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
       this.addedTagList.splice(i, 1);
       this.searchArrayImages(this.searchText, this.searchTerms);
     });
   }

   closeDownloadDialog(boardId: any){
     this.showSmallImg = false;
     this.checkboxes.forEach((element) => {
       element.nativeElement.checked = false;
     });
     this.addedTagList = [];
     this.uploadService.getFiles(this.workspaceId, boardId).subscribe((data: any) => {
       this.fileInfos = data['results'];
       this.totalIllusCount = data['results'].length;
       this.imageExtensionApi();
     });
   }

   closeDialogDownload(){
     this.selectedFormatIndex = 0;
     this.imageDownloadShowFormat = "PNG";
     this.imageDownloadFormat = 'png';
     this.checkboxes.forEach((element) => {
       element.nativeElement.checked = false;
     });
     this.addedTagList = [];
     // this.searchImages(this.searchText);
   }

   imageExtensionApi(){
     this.damService.imagesExtension(this.workspaceId, this.boardId).subscribe((data: any) => {
       this.imagesExtension = data['image_formats'];
     });
   }

   selectFilter(e, searchTxt: string){
     if(e.target.checked){
       this.filterImages(this.boardId, searchTxt);
     }
   }

   addSearchFavouriteImage(imageId: any, imageNameTitle: any, fromPos: any){
     this.damService.addFavouriteImages(this.workspaceId, imageId).subscribe((data: any) => {
       if(fromPos == true) {
         this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
           this.searchText = "";
           this.imagesList = data.image;
           this.searchData = '' + this.searchTextSet;
           this.settingsSection = false;
           this.searchImageslistSection = true;
           for(var i = 0 ; i < this.imagesList.length ; i++) {
             this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
           }
         });
       } else {
         this.searchArrayImages(this.searchText, this.searchTerms);
       }
        this.getFavImagesList();
     });
   }

   downloadMultipleImage(){
     for(let ids of this.imagesIdList){
        this.damService.downloadImages(this.workspaceId, this.boardId, ids.id).subscribe((data: any) => {
            saveAs(data, ids.title)
            this.imagesIdList = [];
            this.changeColor = [];
            this.imageSelected = false;
            this.downloadDelete = false;
            this.count = 0;
         });
     }
   }

   showDownloadDeleteButtons(ivalue: any, i: any, imageId: any, titles: string){
     this.downloadDelete = true;
     this.imageSelected = true;
     if(ivalue == false){
       this.count--;
       if(this.count <= 1){
         this.fileText = 'file';
       }else{
         this.fileText = 'files';
       }
       this.imagesIdList.splice(i, 1);
     }else{
       this.count++;
       if(this.count <= 1){
         this.fileText = 'file';
       }else{
         this.fileText = 'files';
       }
       this.imagesIdList.push({id: imageId, title: titles})
     }
   }

   getNotifications() {
     this.showLoader = true;
     this.newNotification ();
   }

   newNotification () {
     this.googleAnalyticsService.event('get_notifications_settings_screen_click', 'get_notifications_click', this.currentUser.firstName +" "+this.currentUser.lastName);
     this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
       this.notifications = data['notifcation'];
       this.showLoader = false;
     });
   }

   getName(fullEmail: string) {
     return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
   }

   getRandomColor() {
     var color = Math.floor(0x1000000 * Math.random()).toString(16);
     return '#' + ('000000' + color).slice(-6);
   }

   cancelImageSelection(){
     this.count = 0;
     this.imageSelected = false;
     this.downloadDelete = false;
     this.imagesIdList = [];
     this.changeColor = [];
   }

   changeColors(i){
       this.selectedIndex = i;
     }

     updateProfile() {
       this.submitted = true;
       if (this.profileForm.valid) {
         this.showProfileUpdateLoader = true;
         const update_data = {
           first_name: this.profileForm.value['firstName'],
           last_name: this.profileForm.value['lastName']
         }
         this.damService.updateProfiles(this.currentUserData.id, update_data).subscribe((data) => {
           this.sendSuccessful = true;
           this.showProfileUpdateLoader = false;
           this.successfullMessage = "Profile updated successfully!";
           this.hideSuccesfullFunction();
         },(error: any) => {
           if(error.status == 400){
             this.showProfileUpdateLoader = false;
             this.showLeaveLoader = false;
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = error.error.message;
             this.hideSuccesfullFunctionErrorDelete();
           } else {
             this.showProfileUpdateLoader = false;
             this.showLeaveLoader = false;
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = error.error.message;
             this.hideSuccesfullFunctionErrorDelete();
           }
        });
       }
     }

     verifyBoard(boardIds: any){
       this.sendSuccessful = false;
       this.showLeaveLoader = true;
       this.boardIdsList.push(boardIds);
       this.inboxService.verifyBoard(this.workspaceId, this.boardIdsList).subscribe((data: any) => {
         this.showLeaveLoader = false;
         this.sendSuccessful = true;
         this.successfullMessage = data.message;
         this.boardIdsList = [];
         this.hideSuccesfullFunction();
       },(error: any) => {
         if(error.status == 400){
           this.showLeaveLoader = false;
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.boardIdsList = [];
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.showLeaveLoader = false;
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.boardIdsList = [];
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     hideSuccesfullFunctionErrorDelete(){
       setTimeout(() => {
         this.sendSuccessfulErrorMsg = false;
       }, 5000);
     }

     planValidity() {
       this.damService.getPlanValidity(this.planId).subscribe((data: any) => {
         this.planValidityYear = data.year;
         if (data.month == '1') {
           this.planValidityMonth = "Jan";
         } else if (data.month == '2') {
           this.planValidityMonth = "Feb";
         } else if (data.month == '3') {
           this.planValidityMonth = "March";
         } else if (data.month == '4') {
           this.planValidityMonth = "April";
         } else if (data.month == '5') {
           this.planValidityMonth = "May";
         } else if (data.month == '6') {
           this.planValidityMonth = "June";
         } else if (data.month == '7') {
           this.planValidityMonth = "July";
         } else if (data.month == '8') {
           this.planValidityMonth = "Aug";
         } else if (data.month == '9') {
           this.planValidityMonth = "Sept";
         } else if (data.month == '10') {
           this.planValidityMonth = "Oct";
         } else if (data.month == '11') {
           this.planValidityMonth = "Nov";
         } else if (data.month == '12') {
           this.planValidityMonth = "Dec";
         }
         this.planValidityDate = data.date;
         this.planValidityDaysLeft = data.day_remaining;
       });
     }

     hideSuccesfullFunction(){
       setTimeout(() => {
         this.sendSuccessful = false;
         this.pluginDataSaved = false;
         this.showLinkCopied = false;
       }, 3000);
     }

     viewAllWorkspaces() {
       this.router.navigate(['/workspaces']);
     }

     upgradePlan() {
       this.googleAnalyticsService.event('upgrade_plan_tab_settings_screen', 'upgrade_plan_tab', this.currentUser.firstName +" "+this.currentUser.lastName);
       this.router.navigate(['/dam/subscription']);
     }

     newCrafttorDummy(): void {

     }

     showAddSeatsDialogBox() {
       this.showAddSeatsDialog = true;
     }

     addMoreAdmins() {
       this.showMoreAdminsDialog = true;
     }

     chooseIndia(){
       this.radioOthers=false;
       this.radioIndia=true;
       this.isIndia = true;
     }

     chooseOthers(){
       this.radioIndia=false;
       this.radioOthers=true;
       this.isIndia = false;
     }

     chooseIndiaAdmins(){
       this.radioOthersAdmin=false;
       this.radioIndiaAdmin=true;
       this.isIndiaAdmin = true;
     }

     chooseOthersAdmins(){
       this.radioIndiaAdmin=false;
       this.radioOthersAdmin=true;
       this.isIndiaAdmin = false;
     }

     addAdmins(addAdminsCount: any) {
       this.getAdminsAmountApi(addAdminsCount+1);
     }

     subAdmins(addAdminsCount: any) {
       if(addAdminsCount <= 1) {
         // this.getAdminsAmountApi(addAdminsCount);
       } else {
         this.getAdminsAmountApi(addAdminsCount-1);
       }
     }

     addAdminsRazor(addAdminsCount: any) {
       this.getAdminsAmountApiRazor(addAdminsCount+1);
     }

     subAdminsRazor(addAdminsCount: any) {
       if(addAdminsCount <= 1) {
         // this.getAdminsAmountApiRazor(addAdminsCount);
       } else {
         this.getAdminsAmountApiRazor(addAdminsCount-1);
       }
     }

     addSeats(addUserCount: any) {
        this.getSeatAmountApi(addUserCount+1);
     }

     subSeats(addUserCount: any) {
       if(addUserCount <= 1) {
         // this.addUserCount = addUserCount;
         // this.getSeatAmountApi(addUserCount);
         // this.isCustomPlan = false;
       } else {
         // this.addUserCount = addUserCount-1;
         this.getSeatAmountApi(addUserCount-1);
         // this.isCustomPlan = true;
       }
     }

     addSeatsRazor(addUserCount: any) {
        this.getSeatAmountApiRazor(addUserCount+1);
     }

     subSeatsRazor(addUserCount: any) {
       if(addUserCount <= 1) {
         // this.getSeatAmountApiRazor(addUserCount);
       } else {
         this.getSeatAmountApiRazor(addUserCount-1);
       }
     }

     getAdminsAmountApi(userCount: any) {
       this.showMaxAdminsReached = false;
       this.damService.getAdminsAmount(this.planId, userCount).subscribe((data: any) => {
         this.totalAdminPriceFixed = data.new_amount;
         this.addAdminUserCount = userCount;
       },
       (error) => {
         this.showMaxAdminsReached = true;
         this.showAdminsErrorText = error.error.message;
       });
     }

     getAdminsAmountApiRazor(userCount: any) {
       this.showMaxAdminsReached = false;
       this.damService.getAdminsAmountRazor(this.planId, userCount).subscribe((data: any) => {
         this.totalAdminPriceFixed = data.new_amount;
         this.addAdminUserCount = userCount;
         this.razorpayPaymentId = data.razorpay_merchant_key;
         this.razorpayOrderId = data.razorpay_order_id;
       },
       (error) => {
         this.showMaxAdminsReached = true;
         this.showAdminsErrorText = error.error.message;
       });
     }

     getSeatAmountApi(userCount: any) {
       this.showMaxSeatsReached = false;
       this.damService.getSeatAmount(this.planId, userCount).subscribe((data: any) => {
         this.totalPriceFixed = data.new_amount;
         this.addUserCount = userCount;
       },
       (error) => {
         this.showMaxSeatsReached = true;
         this.showSeatsErrorText = error.error.message;
       });
     }

     getSeatAmountApiRazor(userCount: any) {
       this.showMaxSeatsReached = false;
       this.damService.getSeatAmountRazor(this.planId, userCount).subscribe((data: any) => {
         this.totalPriceFixed = data.new_amount;
         this.addUserCount = userCount;
         this.razorpaySeatsPaymentId = data.razorpay_merchant_key;
         this.razorpaySeatsOrderId = data.razorpay_order_id;
       },
       (error) => {
         this.showMaxSeatsReached = true;
         this.showSeatsErrorText = error.error.message;
       });
     }

     payStripeSeats(totalPriceFixed: any) {
       if(totalPriceFixed == 0) {
         this.showMaxSeatsReached = true;
         this.showSeatsErrorText = "Add admin seats."
       } else {
         this.showMaxSeatsReached = false;
         this.showSeatsErrorText = ""
         this.checkoutStripe(totalPriceFixed);
       }
     }

     checkoutStripe(totalPriceFixed: any) {
       const strikeCheckout = (<any>window).StripeCheckout.configure({
         key: environment.STRIPE_LIVE_KEY,
         locale: 'auto',
         token: (stripeToken: any) => {
           this.paymentProcessStyle = "block";
           this.subscriptionService.postStripeOrderAddSeats(stripeToken, totalPriceFixed, 'usd',
             this.planId, this.currentUser.firstName+" "+ this.currentUser.lastName,
             this.address, this.city, this.state, this.country, this.postcode,
             this.totalPriceFixed, this.totalUsers, this.isCustomPlan, this.addUserCount).subscribe((data) => {
             this.paymentProcessStyle = "none";
             this.showSuccesssFullMessage = true;
             this.paymentSuccessStyle = "block";
           },(error: any) => {
             if(error.status == 400){
               this.paymentProcessStyle = "none";
               this.showSuccesssFullMessage = false;
               this.paymentSuccessStyle = "none";
               this.sendSuccessfulErrorMsg = true;
               this.sendSuccessfulErrorMessage = error.error.message;
               this.hideSuccesfullFunctionErrorDelete();
             } else {
               this.paymentProcessStyle = "none";
               this.showSuccesssFullMessage = false;
               this.paymentSuccessStyle = "none";
               this.sendSuccessfulErrorMsg = true;
               this.sendSuccessfulErrorMessage = error.error.message;
               this.hideSuccesfullFunctionErrorDelete();
             }
          });
         }
       });

       strikeCheckout.open({
         name: 'Crafttor',
         description: 'Stripe Payment Gateway',
         image: 'https://crafttor.com/crafttor.jpg',
         currency: 'usd',
         amount: this.totalPriceFixed * 100
       });
     }

     payStripeAdmins(totalAdminPriceFixed: any) {
       if(totalAdminPriceFixed == 0) {
         this.showMaxAdminsReached = true;
         this.showAdminsErrorText = "Add admin seats."
       } else {
         this.showMaxAdminsReached = false;
         this.showAdminsErrorText = ""
         this.checkoutStripeAdminSeats(totalAdminPriceFixed);
       }
     }

     checkoutStripeAdminSeats(totalAdminPriceFixed: any) {
       const strikeCheckout = (<any>window).StripeCheckout.configure({
         key: environment.STRIPE_LIVE_KEY,
         locale: 'auto',
         token: (stripeToken: any) => {
           this.paymentProcessStyle = "block";
           this.subscriptionService.postStripeOrderAddAdminSeats(stripeToken, totalAdminPriceFixed, 'usd',
             this.planId, this.currentUser.firstName+" "+ this.currentUser.lastName,
             this.address, this.city, this.state, this.country, this.postcode,
             this.totalAdminPriceFixed, this.totalUsers, this.isCustomPlan, this.addAdminUserCount).subscribe((data) => {
             this.paymentProcessStyle = "none";
             this.showSuccesssFullMessage = true;
             this.adminPaymentSuccessStyle = "block";
           },(error: any) => {
             if(error.status == 400){
               this.paymentProcessStyle = "none";
               this.showSuccesssFullMessage = false;
               this.adminPaymentSuccessStyle = "none";
               this.sendSuccessfulErrorMsg = true;
               this.sendSuccessfulErrorMessage = error.error.message;
               this.hideSuccesfullFunctionErrorDelete();
             } else {
               this.paymentProcessStyle = "none";
               this.showSuccesssFullMessage = false;
               this.adminPaymentSuccessStyle = "none";
               this.sendSuccessfulErrorMsg = true;
               this.sendSuccessfulErrorMessage = error.error.message;
               this.hideSuccesfullFunctionErrorDelete();
             }
          });
         }
       });

       strikeCheckout.open({
         name: 'Crafttor',
         description: 'Stripe Payment Gateway',
         image: 'https://crafttor.com/crafttor.jpg',
         currency: 'usd',
         amount: this.totalPriceFixed * 100
       });
     }

   stripePaymentGateway() {
     if(!window.document.getElementById('stripe-script')) {
       const scr = window.document.createElement("script");
       scr.id = "stripe-script";
       scr.type = "text/javascript";
       scr.src = "https://checkout.stripe.com/checkout.js";

       scr.onload = () => {
         this.strikeCheckout = (<any>window).StripeCheckout.configure({
           key: environment.STRIPE_LIVE_KEY,
           locale: 'auto',
           token: function (token: any) {
           console.log(token)
           alert('Payment via stripe successfull!');
           }
         });
       }
       window.document.body.appendChild(scr);
       }
     }

     hideSuccesfullFunctionShowPaySuccess(){
       setTimeout(() => {
         this.showSuccesssFullMessage = false;
         this.router.navigate(['/dam/settings']);
       }, 2000);
     }

     closePaymentSuccessDialog() {
       this.paymentSuccessStyle = "none";
       this.router.navigate(['/dam']);
     }

     closeAdminPaymentSuccessDialog() {
       this.adminPaymentSuccessStyle = "none";
       this.router.navigate(['/dam']);
     }

     payRazorSeats(totalPriceFixed: any) {
       if(totalPriceFixed == 0) {

       } else {
         this.payWithRazor(totalPriceFixed);
       }
     }

     payWithRazor(totalPriceFixed: any) {
       let self = this;
       localStorage.setItem('paymentRazorDetails', JSON.stringify({ totalAmount: totalPriceFixed}));
       const options: any = {
         key: this.razorpaySeatsPaymentId,
         amount: totalPriceFixed*100,
         currency: 'USD',
         name: 'Crafttor',
         description: '',
         image: 'https://crafttor.com/crafttor.jpg',
         order_id: this.razorpaySeatsOrderId,
         modal: {
           escape: false,
         },
         notes: {

         },
         theme: {
           color: '#0c238a'
         }
       };
       var that = this;
       options.handler = ((response, error) => {
         options.response = response;
         that.userRazorPayName = that.currentUser.firstName+" "+ that.currentUser.lastName;
         that.subscriptionService.postRazorOrderAddSeats(that.userRazorPayName, totalPriceFixed,
           "USD", that.planId, that.addUserCount, response.razorpay_payment_id,
             response.razorpay_order_id,response.razorpay_signature).subscribe((data) => {
               that.router.navigate(['/dam/payment-success']);
         },(error: any) => {
           if(error.status == 400){
             self.alert.error(error.error.message)
           } else {
             self.alert.error(error.error.message)
           }
        });
       });
       options.modal.ondismiss = (() => {
         console.log('Transaction cancelled.');
       });
       const rzp = new this.winRef.nativeWindow.Razorpay(options);
       rzp.open();
       // this.hideSuccesfullFunctionMsg();
     }

     payRazorAdmins(totalPriceFixedRazor: any) {
       if(totalPriceFixedRazor == 0) {

       } else {
         this.payWithRazorAdminSeats(totalPriceFixedRazor);
       }
     }

     payWithRazorAdminSeats(totalPriceFixedRazor: any) {
       let self = this;
       localStorage.setItem('paymentRazorDetails', JSON.stringify({ totalAmount: totalPriceFixedRazor}));
       const options: any = {
         key: this.razorpayPaymentId,
         amount: totalPriceFixedRazor*100,
         currency: 'USD',
         name: 'Crafttor',
         description: '',
         image: 'https://crafttor.com/crafttor.jpg',
         order_id: this.razorpayOrderId,
         modal: {
           escape: false,
         },
         notes: {

         },
         theme: {
           color: '#0c238a'
         }
       };
       var that = this;
       options.handler = ((response, error) => {
         const rzp = new this.winRef.nativeWindow.Razorpay(options);
         rzp.close();
         options.response = response;
         that.userRazorPayName = that.currentUser.firstName+" "+ that.currentUser.lastName;
         that.subscriptionService.postRazorOrderAddAdminSeats(that.userRazorPayName, totalPriceFixedRazor,
           "USD", that.planId, that.addAdminUserCount, response.razorpay_payment_id,
             response.razorpay_order_id,response.razorpay_signature).subscribe((data) => {
               that.router.navigate(['/dam/payment-success']);
         },(error: any) => {
           if(error.status == 400){
             self.alert.error(error.error.message)
           } else {
             self.alert.error(error.error.message)
           }
        });
       });
       options.modal.ondismiss = (() => {
         console.log('Transaction cancelled.');
       });
       const rzp = new this.winRef.nativeWindow.Razorpay(options);
       rzp.open();
       // this.hideSuccesfullFunctionMsg();
     }

     hideSuccesfullFunctionMsg(){
       setTimeout(() => {
         this.paymentRazorProcessStyle = "block";
       }, 5000);
     }

     shareBoard(boardId: any) {
       this.fromAssets = false;
       this.shareImageLink = "";
       this.hitShareBoardApi(boardId);
     }

     hitShareBoardApi(boardId: any) {
       this.subscriptionService.hitBoardShare(this.workspaceId, boardId, "").subscribe((data) => {
         this.shareableLink = data.link;
         this.sharedToken = data.token;
         this.shareLinkStyle = "block";
         this.hideContent();
       },(error: any) => {
         this.hideContent();
         if(error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     hideContent() {
       this.imagesIdList = [];
       this.changeColor = [];
       this.imageSelected = false;
       this.downloadDelete = false;
       this.count = 0;
     }

     closeShareLinkStyle() {
       this.imagesIds = [];
       this.shareLinkStyle = "none";
     }

     showGeneratedLink() {
       this.isShowShareLinkGenerated = true;
     }

     copyShareLink(inputElement){
       if(this.allowDownloadSelected) {
         this.allowDownloads = 1;
       } else {
         this.allowDownloads = 0;
       }

       if(this.showCommentSelected) {
         this.showComments = 1;
       } else {
         this.showComments = 0;
       }

       if(this.allowCommentingSelected) {
         this.allowComments = 1;
       } else {
         this.allowComments = 0;
       }

       if(this.fromAssets) {
         this.subscriptionService.shareAssetsSettingsData(this.sharedToken,
           this.allowDownloads, this.expiryLinkIn, this.showComments, this.allowComments).subscribe((data) => {

         },(error: any) => {
           if(error.status == 400){
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = error.error.message;
             this.hideSuccesfullFunctionErrorDelete();
           } else {
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = error.error.message;
             this.hideSuccesfullFunctionErrorDelete();
           }
         });
       } else {
         this.subscriptionService.shareBoardsSettingsData(this.sharedToken,
           this.allowDownloads, this.expiryLinkIn, this.showComments, this.allowComments).subscribe((data) => {

         },(error: any) => {
           if(error.status == 400){
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = error.error.message;
             this.hideSuccesfullFunctionErrorDelete();
           } else {
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = error.error.message;
             this.hideSuccesfullFunctionErrorDelete();
           }
         });
       }
       inputElement.select();
       document.execCommand('copy');
       this.showLinkCopied = true;
       inputElement.setSelectionRange(0, 0);
       this.hideSuccesfullFunction();
     }

     allWorkspaceResolution() {
       if(this.isAllWorkspaceSelected) {
         this.isAllWorkspaceSelected = false;
       } else {
         this.isAllWorkspaceSelected = true;
       }
     }

     selectOptionBoard(boardId: any) {
       this.pluginBoardId = boardId;
     }

     getPercent(percent: any) {
       this.rangeValue = percent;
     }

     applyBoardsClick() {
       if(this.isAllWorkspaceSelected) {
         this.pluginDataSaved = true;
         this.pluginMsg = "All workspaces enabled. Please disable first."
         this.hideSuccesfullFunction();
       }
     }

     allWorkspaceSelected() {
       if(this.isAllWorkspaceSelected) {
         this.optionDisabled = false;
         this.isAllBoardSelected = false;
         this.isBoardDisabled = false;
         this.isSelectEnabled = true;
       } else {
         this.isAllBoardSelected = true;
         this.isSelectEnabled = false;
         this.allBoardChecked = false;
         this.isBoardDisabled = true;
         this.optionDisabled = true;
       }
     }

     allBoardResolution() {
       if(this.isAllBoardSelected) {
         this.optionDisabled = false;
         this.isAllBoardSelected = false;
         this.isSelectEnabled = true;
       } else {
         this.optionDisabled = true;
         this.isAllBoardSelected = true;
         this.isSelectEnabled = false;
       }
       // else if(this.isAllWorkspaceSelected){
       //   this.optionDisabled = true;
       //   this.isAllBoardSelected = false;
       //   this.isSelectEnabled = false;
       // }
     }

     saveAssetsSettings() {
       this.googleAnalyticsService.event('saved_assetsseetings_settings_screen', 'saved_assetsseetings', this.currentUser.firstName +" "+this.currentUser.lastName);
       this.subscriptionService.pluginResolution(this.workspaceId, this.isAllWorkspaceSelected,
         this.isAllBoardSelected, this.rangeValue, this.pluginBoardId).subscribe((data) => {
           if(data.message != null) {
             this.pluginDataSaved = true;
             this.pluginMsg = data.message;
           }
           this.hideSuccesfullFunction();
           this.hideContent();
       },(error: any) => {
         this.hideContent();
         this.pluginDataSaved = false;
         if(error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     clickMyAccount() {
       this.googleAnalyticsService.event('myaccount_tab_settings_screen_click', 'myaccount_tab_click', this.currentUser.firstName +" "+this.currentUser.lastName);
     }

     clickWorkspaceTab() {
       this.googleAnalyticsService.event('workspace_tab_settings_screen_click', 'workspace_tab_click', this.currentUser.firstName +" "+this.currentUser.lastName);
     }

     clickPlanTab() {
       this.googleAnalyticsService.event('plan_tab_settings_screen_click', 'plan_tab_click', this.currentUser.firstName +" "+this.currentUser.lastName);
     }

     getAssetSettings() {
       this.googleAnalyticsService.event('assets_tab_settings_screen_click', 'assets_tab_click', this.currentUser.firstName +" "+this.currentUser.lastName);
       this.subscriptionService.getPluginResolution(this.workspaceId).subscribe((data) => {
         this.rangeValue = data.asset_quality_percentage;
         this.allBoardChecked = data.is_all_board_quality;
         this.isAllBoardSelected = data.is_all_board_quality;
         this.isAllWorkspaceSelected = data.is_all_worksapce_quality;
         this.selectedBoardsList = data['board_list'];
         if(this.selectedBoardsList.length > 0) {
           this.showAppliedBoard = true;
         } else if (this.selectedBoardsList.length == 0 || this.selectedBoardsList == null ) {
           this.showAppliedBoard = false;
         } else if (this.allBoardChecked == true || this.isAllWorkspaceSelected == true) {
           this.showAppliedBoard = false;
         }
         if(this.isAllWorkspaceSelected) {
           this.isSelectEnabled = false;
           this.allBoardChecked = false;
           this.isBoardDisabled = true;
           this.optionDisabled = true;
         } else if (this.allBoardChecked) {
           this.isSelectEnabled = true;
           this.allBoardChecked = true;
           this.isBoardDisabled = false;
           this.optionDisabled = true;
         }

       },(error: any) => {
         this.hideContent();
         if(error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     hitOwnerApi() {
       this.ownerListApi();
     }

     applyStackingCouponsTwoSettings(couponCode: any) {
       this.googleAnalyticsService.event('coupon_applied_settings_screen', 'coupon_applied ' + couponCode, this.currentUser.firstName +" "+this.currentUser.lastName);
       this.startApplyCouponLoader = true;
       this.subscriptionService.sendStackingCoupons(couponCode).subscribe((data) => {
           this.coupon2Value = "";
           this.hitOwnerApi();
           this.startApplyCouponLoader = false;
           this.showCouponTwoField = false;
           this.showCouponThreeField = true;
       },(error: any) => {
         this.hideContent();
         this.pluginDataSaved = false;
         if(error.status == 400){
           this.startApplyCouponLoader = false;
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.startApplyCouponLoader = false;
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     applyStackingCouponsThreeSettings(couponCode: any) {
       this.startApplyCouponLoader = true;
       this.subscriptionService.sendStackingCoupons(couponCode).subscribe((data) => {
           this.coupon3Value = "";
           this.hitOwnerApi();
           this.startApplyCouponLoader = false;
           this.showCouponTwoField = false;
           this.showCouponThreeField = true;
       },(error: any) => {
         this.hideContent();
         this.pluginDataSaved = false;
         if(error.status == 400){
           this.startApplyCouponLoader = false;
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.startApplyCouponLoader = false;
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     goToMarketplace() {
       window.open("https://crafttor.com/marketplace", "_blank");
     }

     goToFeedback() {
       window.open("https://workspace.crafttor.com/feedbacks", "_blank");
     }

     // getInitial(fullEmail: string) {
     //   const initials = fullEmail.split(' ')
     //                      .map(word => word.charAt(0))
     //                      .join('')
     //                      .slice(0, 2)
     //                      .toUpperCase();
     //                      return initials;
     // }

     getInitial(fullEmail: string) {
       const words = fullEmail.split(' ');
       let initials = '';

       if (words.length > 2) {
         initials = words.slice(0, 2).map(word => word.charAt(0)).join('').toUpperCase();
       } else {
         initials = words.map(word => word.charAt(0)).join('').toUpperCase();
       }

       return initials;
      }

     showDownloadPopup() {
       if(this.showDownloadDialog == true) {
         this.showDownloadDialog = false;
       } else if(this.showDownloadDialog == false){
         this.showDownloadDialog = true;
       }
     }

     changeFormatColors(i){
         this.selectedFormatIndex = i;
     }

     getImage(currentImage: any, format: any) {
       this.imageDownloadShowFormat = format;
       if (format == 'PNG') {
         this.imageDownloadFormat = 'png';
       } else if (format == 'JPEG') {
         this.imageDownloadFormat = 'jpeg';
       } else if (format == 'TIFF') {
         this.imageDownloadFormat = 'tiff';
       } else if (format == 'WEBP') {
         this.imageDownloadFormat = 'webp';
       } else if (format == 'SVG') {
         this.imageDownloadFormat = 'svg';
       } else if (format == 'GIF') {
         this.imageDownloadFormat = 'GIF';
       } else if (format == 'AI') {
         this.imageDownloadFormat = 'ai';
       } else if (format == 'BMP') {
         this.imageDownloadFormat = 'bmp';
       }
     }

     downloadFormatImage(currentImageId: any, titleImage: string, boardId: any): void {
       this.showDownloadLoader = true;
       this.damService.downloadFormatImages(this.workspaceId, boardId, currentImageId, this.imageDownloadFormat).subscribe((data: any) => {
         let stringToSplit = titleImage;
         let imageName = stringToSplit.split(".");
         saveAs(data, imageName[0])
         this.showDownloadLoader = false;
         this.showDownloadDialog = false;
       },
         (error: any) => {
           this.showDownloadLoader = false;
           if (error.status === 403) {
             // this.openLimitModal(this.limitModal);
           }
           else {
             // this.alert.alert("Alert", "Limit reached! Please login to download")
           }
         }
       );
     }

     @ViewChild(PdfViewerComponent, {static: false})
     private pdfComponent: PdfViewerComponent;
     pageRendered() {
       this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
     }

     nextSearchImage(currentIllusPos: any) {
       this.showSearchNextIcon = true;
       this.showSearchPreviosIcon = true;
       this.selectedFormatIndex = 0;
       this.imageDownloadShowFormat = "PNG";
       this.imageDownloadFormat = 'png';
       this.showDownloadDialog = false;
       this.closeImageEditField();
       this.addedTagList = [];
       if(currentIllusPos == this.imagesList.length-2) {
         this.showSearchNextIcon = false;
       }
       if(currentIllusPos <= this.imagesList.length) {
         for(var i = 0 ; i < this.imagesList.length ; i++) {
           this.currentIllus = this.imagesList[currentIllusPos+1];
           this.selectedVersion = this.currentIllus.current_cover;
           this.imageHeading = this.currentIllus.title;
           this.favImageHeading = this.currentIllus.title;
           this.hideEditImageName = true;
           this.hideEditFavImageName = true;
         }
         this.currentIllus.is_fav = this.currentIllus.is_fav;
         this.suggestedTags = [];
         this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
         this.commentsList = [];
         this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
         this.currentSearchIllusPosition = currentIllusPos+1;
       } else {
         //
       }
     }

     previousSearchImage(currentIllusPos: any) {
       this.showSearchNextIcon = true;
       this.showSearchPreviosIcon = true;
       this.selectedFormatIndex = 0;
       this.imageDownloadShowFormat = "PNG";
       this.imageDownloadFormat = 'png';
       this.showDownloadDialog = false;
       this.closeImageEditField();
       this.addedTagList = [];
       if(currentIllusPos == 0) {
         this.showSearchPreviosIcon = false;
       } else {
         for(var i = 0 ; i < this.imagesList.length ; i++) {
           this.currentIllus = this.imagesList[currentIllusPos-1];
           this.selectedVersion = this.currentIllus.current_cover;
           this.imageHeading = this.currentIllus.title;
           this.favImageHeading = this.currentIllus.title;
           this.hideEditImageName = true;
           this.hideEditFavImageName = true;
         }
         this.currentIllus.is_fav = this.currentIllus.is_fav;
         this.suggestedTags = [];
         this.getSuggestedTags(this.currentIllus.board, this.currentIllus.id);
         this.commentsList = [];
         this.getAssetsComments(this.currentIllus.board, this.currentIllus.id);
         this.currentSearchIllusPosition = currentIllusPos-1;
       }
     }

     deleteSearchImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
       this.damService.deleteImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
         // this.uploadService.getFiles(this.workspaceId, this.boardId).subscribe((data: any) => {
         //   this.imagesList = data['results'];
         //   this.totalIllusCount = data['results'].length;
         //
         //   for(var i = 0 ; i < this.imagesList.length ; i++) {
         //     this.currentIllus = this.imagesList[currentIllusPos];
         //   }
         // });
         this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
           this.imagesList = data.image;
           this.searchData = this.searchText;
           this.settingsSection = false;
           this.searchImageslistSection = true;
           for(var i = 0 ; i < this.imagesList.length ; i++) {
             this.currentIllus = this.imagesList[currentIllusPos];
           }
         });
       },
       (error) => {
         if(error.status == 403 || error.status == 401 || error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     makeCoverImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
       this.damService.makeCoverImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
         this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
           this.imagesList = data.image;
           this.searchData = this.searchText;
           this.settingsSection = false;
           this.searchImageslistSection = true;
           for(var i = 0 ; i < this.imagesList.length ; i++) {
             this.currentIllus = this.imagesList[currentIllusPos];
           }
         });
       },
       (error) => {
         if(error.status == 403 || error.status == 401 || error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     selectFilesVersion(event, currentIllusPos: any, boardHeading: string, boardId: any, imageId: any): void {
       this.progressInfos = [];
       this.replaceAsset = true;

       const files = event.target.files;
       let isImage = true;
       for (let i = 0; i < files.length; i++) {
         if (files.item(i).type.match('pdf.*') || files.item(i).type.match('image.*') || files.item(i).type.match('video.*')) {
           continue;
         } else {
           isImage = false;
           alert('Invalid Format!');
           break;
         }
       }

       if (isImage) {
         this.selectedFiles = event.target.files;
         this.uploadFilesVersion(event, currentIllusPos, boardHeading, boardId, imageId);
       } else {
         this.selectedFiles = undefined;
         event.srcElement.percentage = null;
       }
     }

     uploadFilesVersion(event, currentIllusPos, boardHeading: string, boardId: any, imageId: any): void {
       this.message = '';
       for (let i = 0; i < this.selectedFiles.length; i++) {
         // this.getImageResolution(this.selectedFiles[i], i, );
         this.addVersionImage(i, currentIllusPos, this.selectedFiles[i], boardHeading, boardId, imageId);
       }
     }

     addVersionImage(idx, currentIllusPos: any, file, boardHeading: string, boardId: any, imageId: any): void {
       this.progressInfos[idx] = { value: 0, fileName: file.name };
       this.uploadService.uploadImageVersion(file, file.name, boardHeading, boardId, this.workspaceId, imageId).subscribe(
         event => {
           if (event.type === HttpEventType.UploadProgress) {
             this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
             this.progressPecentage = this.progressInfos[idx].percentage;
           } else if (event instanceof HttpResponse) {
             this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
               this.imagesList = data.image;
               this.searchData = this.searchText;
               this.settingsSection = false;
               this.searchImageslistSection = true;
               for(var i = 0 ; i < this.imagesList.length ; i++) {
                 this.currentIllus = this.imagesList[currentIllusPos];
               }
             });
           }
         },
         (error: any) => {
           if(error.status == 400){
             this.isShowLoadingStatusDone = false;
             this.isShowLoadingStatus = false;
             this.uploadedFileName = error.error.title.title;
             this.openUploadOptionsStyleBoard();
           } else {
             this.isShowLoadingStatusDone = false;
             this.isShowLoadingStatus = false;
             this.alert.error("Something went wrong");
           }
        }
       );
     }

     setMainImage(imgLink: any, version: any) {
       this.selectedVersion = version;
       this.currentIllus.image = imgLink;
     }

     downloadVersionImage(currentImageId: any, titleImage: string, boardId: any, version: any): void {
       this.damService.downloadVersionImages(this.workspaceId, boardId, currentImageId, version).subscribe((data: any) => {
         saveAs(data, titleImage)
       },
         (error: any) => {
           if (error.status === 403) {
             // this.openLimitModal(this.limitModal);
           }
           else {
             // this.alert.alert("Alert", "Limit reached! Please login to download")
           }
         }
       );
     }

     openVersionImages() {
       this.showSmallImg = true;
     }

     closeVersionImages() {
       this.showSmallImg = false;
     }

     openUploadOptionsStyleBoard() {
       this.uploadOptionsStyle = "block";
     }

     closeUploadOptionsStyleBoard() {
       this.uploadOptionsStyle = "none";
     }

     showUploadReplaceDialog() {
       this.uploadVersionStyle = "block";
     }

     closeUploadReplaceDialog() {
       this.uploadVersionStyle = "none";
     }

     openFigma() {
       this.googleAnalyticsService.event('figma_settings_screen', 'figma_icon', this.currentUser.firstName +" "+this.currentUser.lastName);
       window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
     }

     openSketch() {
       this.googleAnalyticsService.event('sketch_settings_screen', 'sketch_icon', this.currentUser.firstName +" "+this.currentUser.lastName);
       window.open("https://crafttor.com/sketch", "_blank");
     }

     openIllustrator() {
       this.googleAnalyticsService.event('sai_settings_screen', 'ai_icon', this.currentUser.firstName +" "+this.currentUser.lastName);
       window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
     }

     onSubmitReplyComment(imgId: any, commentId: any, replyMsg: any, boardId: any) {
       if(this.userSelectedForReplyTag) {
         this.taggingComments(boardId, imgId, commentId, replyMsg, this.selectedUserIdForTag)
       } else {
         this.postAssetsReplyComments(imgId, commentId, replyMsg);
       }
     }

     onSubmitCommentSection(imgId: any, mainMsg: any, boardId: any) {
       if(this.userSelectedForTag) {
         this.taggingComments(boardId, imgId, "", mainMsg, this.selectedUserIdForTag)
       } else {
         this.postAssetsComments(imgId, mainMsg);
       }
     }

     postAssetsComments(imageId: any, mainMsg: any) {
       this.openEditBox = false;
       if (this.mainMsgForm.valid) {
         this.showChatLoader = true;
         this.damService.postAssetComment(this.workspaceId, this.boardId, imageId,
           this.commentId, mainMsg).subscribe((data) => {
             this.selectedUserIdForTag = "";
             this.showChatLoader = false;
             this.commentMsg = "";
             this.replyMsg = "";
             this.textArea = "";
             this.mainMsgForm.reset();
             this.getAssetsComments(this.boardId, imageId);
         },
         (error: any) => {
           if(error.status == 400 || error.status == 403){
           } else {
             // this.getUnResolveComments(this.boardId, imageId);
           }
        });
       }
     }

     postAssetsReplyComments(imageId: any, commentId: any, replyMsg: any) {
       this.openEditBox = false;
       this.submitted = true;
       if (this.replyForm.valid) {
         this.damService.postAssetComment(this.workspaceId, this.boardId, imageId,
           commentId, replyMsg).subscribe((data) => {
             this.selectedUserIdForTag = "";
             this.commentMsg = "";
             this.replyMsg = "";
             this.replyArea = "";
             this.replyForm.reset();
             this.getAssetsComments(this.boardId, imageId);
         },
         (error: any) => {
           if(error.status == 400 || error.status == 403){
             // this.getUnResolveComments(this.boardId, imageId);
           } else {
             // this.getUnResolveComments(this.boardId, imageId);
           }
        });
       }
     }

     getAssetsComments(boardId: any, assetId: any) {
       this.openEditBox = false;
       this.damService.getAssetComment(this.workspaceId, boardId, assetId).subscribe((data) => {
           this.commentsList = data['results'];
           this.noComments = "No comments!!";
           this.damService.getAllUsersList(this.workspaceId).subscribe((data: any) => {
             this.usersList = data;
           });
       });
     }

     deleteComments(boardId: any, assetId: any, commentId: any) {
       this.openEditBox = false;
       this.damService.deleteAssetComment(this.workspaceId, boardId, assetId, commentId).subscribe((data) => {
         this.getAssetsComments(boardId, assetId);
       });
     }

     public editComments(boardId: any, assetId: any, commentId: any) {
       this.submitted = true;
       if (this.commentForm.valid) {
         this.damService.editAssetComment(this.workspaceId, boardId, assetId, commentId,
           this.commentForm.value.comment).subscribe((data) => {
           this.openEditBox = false;
           this.editComment = "";
           this.commentForm.value.comment = "";
           this.getAssetsComments(boardId, assetId);
         });
       }
     }

     public getUnResolveComments(boardId: any, assetId: any) {
       this.openEditBox = false;
       this.damService.unResolveComment(this.workspaceId, boardId, assetId).subscribe((data) => {
         this.commentsList = data['results'];
         this.noComments = "No open comments!!";
       });
     }

     public resolvedListComments(boardId: any, assetId: any) {
       this.openEditBox = false;
       this.damService.resolvedListComment(this.workspaceId, boardId, assetId).subscribe((data) => {
         this.commentsList = data['results'];
         this.noComments = "No resolved comments!!";
       });
     }

     public postResolvedComments(boardId: any, assetId: any, commentId: any) {
       this.openEditBox = false;
       this.damService.resolvedComment(this.workspaceId, boardId, assetId, commentId).subscribe((data) => {
         this.getUnResolveComments(boardId, assetId);
       });
     }

     public taggingComments(boardId: any, assetId: any, commentId: any, commentMsg: any, userId: any) {
       this.openEditBox = false;
       if(commentMsg != "" || commentMsg != null) {
         this.showChatLoader = true;
         this.damService.taggingComment(this.workspaceId, boardId, assetId,
           commentId, commentMsg, userId).subscribe((data) => {
             this.selectedUserIdForTag = "";
             this.showChatLoader = false;
             this.commentMsg = "";
             this.replyMsg = "";
             this.textArea = "";
             this.replyArea = "";
             this.replyForm.reset();
             this.mainMsgForm.reset();
             this.getAssetsComments(this.boardId, assetId);
         });
       }
     }

     openEditComment () {
       this.openEditBox = true;
     }

     openReplyBoxes(index) {
       this.showChatLoader = false;
       this.replyMsg = "";
       this.replyArea = "";
       this.replyForm.reset();
       this.index = index;
     }

     public isEmojiPickerVisible: boolean;
     @ViewChild("mainMsgData") commentField;

     public addEmoji(event) {
       this.textArea = `${this.textArea}${event.emoji.native}`;
       this.isEmojiPickerVisible = false;
       this.commentField.nativeElement.focus();
     }

     public isEmojiPickerVisibleReply: boolean;
     @ViewChild("replyData") replyField;

     public addReplyEmoji(event) {
       this.replyArea = `${this.replyArea}${event.emoji.native}`;
       this.isEmojiPickerVisible = false;
     }

     makeSearchCoverImageVersion(currentIllusPos: any, version: any, boardId: any, imageId: any) {
       this.damService.makeCoverImageVersion(this.workspaceId, boardId, imageId, version).subscribe((data: any) => {
         this.damService.searchImages(this.workspaceId, this.searchTextSet).subscribe((data: any) => {
           this.imagesList = data.image;
           this.searchData = this.searchText;
           this.settingsSection = false;
           this.searchImageslistSection = true;
           this.selectedVersion = version;
           for(var i = 0 ; i < this.imagesList.length ; i++) {
             this.currentIllus = this.imagesList[currentIllusPos];
           }
         });
       },
       (error) => {
         if(error.status == 403 || error.status == 401 || error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     hitUsersListApi(event) {
       if(event.target.value === "@") {
         this.showUsersListDialog = true;
       } else if(event.target.value === "") {
         this.selectedUserIdForTag = "";
         this.showUsersListDialog = false;
         this.userSelectedForTag = false;
       } else {
         this.showUsersListDialog = false;
       }
     }

     selectedTagUser(userId: any, userFirstName: string) {
       this.showUsersListDialog = false;
       this.userSelectedForTag = true;
       this.selectedUserIdForTag = userId;
       this.textArea = userFirstName;
       this.selectedUserNameForTag = userFirstName;
     }

     hitUsersListReplyApi(event) {
       if(event.target.value === "@") {
         this.showUsersListReplyDialog = true;
       } else if(event.target.value === "") {
         this.selectedUserIdForTag = "";
         this.showUsersListReplyDialog = false;
         this.userSelectedForReplyTag = false;
       } else {
         this.showUsersListReplyDialog = false;
       }
     }

     selectedReplyTagUser(userId: any, userFirstName: string) {
       this.showUsersListReplyDialog = false;
       this.userSelectedForReplyTag = true;
       this.selectedUserIdForTag = userId;
       this.replyArea = userFirstName;
     }

     resetFields() {
       this.commentMsg = "";
       this.replyMsg = "";
       this.textArea = "";
       this.replyArea = "";
       this.replyForm.reset();
       this.mainMsgForm.reset();
     }

     hideErrorMsg() {
       this.showMaxAdminsReached = false;
       this.showAdminsErrorText = "";
     }

     hideSeatsErrorMsg() {
       this.showSeatsErrorText = "";
       this.showMaxSeatsReached = true;
     }

     pinBoard(boardId: any) {
       this.damService.pinBoards(this.workspaceId, boardId).subscribe((data: any) => {
           this.reStartListing();
       },
       (error) => {
         if(error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
       });
     }

     unPinBoard(boardId: any) {
       this.damService.unPinBoards(this.workspaceId, boardId).subscribe((data: any) => {
           this.reStartListing();
       },
       (error) => {
         if(error.status == 400){
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.hideSuccesfullFunctionErrorDelete();
         }
       });
     }

     onSubmit() {
       if(this.searchText.length > 0) {
         this.searchTerms.push(this.searchText);
         this.searchArrayImages(this.searchText, this.searchTerms);
       }
     }

     searchArrayImages(searchText: any, searchTermArray: any){
       this.downloadDelete = false;
       this.imagesIdList = [];
       this.changeColor = [];
       this.imageSelected = false;
       this.searchTextSet = searchText;
       this.damService.searchImagesArray(this.workspaceId, searchTermArray).subscribe((data: any) => {
         this.searchText = "";
         this.imagesList = data.image;
         this.searchData = '' + this.searchTextSet;
         this.settingsSection = false;
         this.searchImageslistSection = true;
       });
     }

     removeSearchTerm(index: number, searchTerm: any) {
       this.searchTerms.splice(index, 1);
       if(this.searchTerms.length > 0) {
         this.searchArrayImages(searchTerm, this.searchTerms);
       } else {
         this.settingsSection = false;
         this.searchImageslistSection = true;
         this.imagesList = [];
       }
     }

     archiveSingleSearchImage(imgId: any, pos: any, boardId: any, imgTitle: any) {
       this.showTopRightLoader = true;
       this.damService.archiveSingleImages(this.workspaceId, boardId, imgId).subscribe((data: any) => {
         this.showTopRightLoader = false;
         this.sendSuccessful = true;
         this.successfullMessage = imgTitle + " moved to trash";
         this.hideSuccesfullFunction();
         this.searchArrayImages(this.searchText, this.searchTerms);
       });
     }

     openMoveImagesStyleBoard(imageId: any, moveFromScreen: any, pos: any, boardId: any){
       this.moveFromSearch = moveFromScreen;
       this.imagesIds.push(imageId);
       this.damService.getMoveBoardsList(this.workspaceId, boardId).subscribe((data: any) => {
         this.moveBoards = data;
       },
         (error: any) => {
           if (error.status == 403) {
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = error.error.message;
             this.hideSuccesfullFunctionErrorDelete();
           }
           else {
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = "Something went wrong!";
             this.hideSuccesfullFunctionErrorDelete();
           }
         }
       );
       this.moveImagesStyle = "block";
     }

     downloadSingleImage(imgId: any, imgTitle: string, boardId: any){
       this.damService.downloadImages(this.workspaceId, boardId, imgId).subscribe((data: any) => {
           saveAs(data, imgTitle)
           this.imagesIdList = [];
           this.imagesIds = [];
           this.changeColor = [];
           this.imageSelected = false;
           this.downloadDelete = false;
           this.count = 0;
        },(error) => {
          const errors = error.error || error.statusText;
          Object.keys(errors).map((key) => {
            errors[key].map((message) => {
              this.sendSuccessfulErrorMsg = true;
              this.sendSuccessfulErrorMessage = message;
              this.hideSuccesfullFunctionErrorDelete();
              this.imagesIdList = [];
              this.imagesIds = [];
              this.changeColor = [];
              this.imageSelected = false;
              this.downloadDelete = false;
              this.count = 0;
            })
          })
        });
     }

     verifyAssets(assetsIds: any){
       this.sendSuccessful = false;
       this.showTopRightLoader = true;
       this.asssetsIdsList.push(assetsIds);
       this.inboxService.verifyAssets(this.workspaceId, this.asssetsIdsList).subscribe((data: any) => {
         this.showTopRightLoader = false;
         this.sendSuccessful = true;
         this.successfullMessage = data.message;
         this.asssetsIdsList = [];
         this.hideSuccesfullFunction();
       },(error: any) => {
         if(error.status == 400){
           this.showTopRightLoader = false;
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.asssetsIdsList = [];
           this.hideSuccesfullFunctionErrorDelete();
         } else {
           this.showTopRightLoader = false;
           this.sendSuccessfulErrorMsg = true;
           this.sendSuccessfulErrorMessage = error.error.message;
           this.asssetsIdsList = [];
           this.hideSuccesfullFunctionErrorDelete();
         }
      });
     }

     closeMoveImagesStyleBoard() {
      this.moveImagesStyle = "none";
      this.boardSearchKeyword = '';
      this.showSearchBoardOlderList = true;
      this.showSearchBoardList = false;
     }

     moveImagesToOtherBoard(newBoardId: any, boardTitle: string) {
       this.sendSuccessful = false;
       this.downloadDelete = false;
       this.closeMoveImagesStyleBoard();
       this.showTopRightLoader = true;
       this.damService.moveImagesToOtherBoard(this.workspaceId, this.boardId,
         this.imagesIds, newBoardId).subscribe((data: any) => {
           // this.closeDeleteStyleBoard();
           this.showTopRightLoader = false;
           this.sendSuccessful = true;
           this.successfullMessage = data.message;
           this.settingsSection = false;
           this.searchImageslistSection = true;
           this.hideSuccesfullFunction();
           this.searchArrayImages(this.searchText, this.searchTerms);
       },(error) => {
         this.closeMoveImagesStyleBoard();
         this.showTopRightLoader = false;
         const errors = error.error || error.statusText;
         Object.keys(errors).map((key) => {
           errors[key].map((message) => {
             this.imagesIdList = [];
             this.imagesIds = [];
             this.changeColor = [];
             this.imageSelected = false;
             this.downloadDelete = false;
             this.showSearchBoardOlderList = true;
             this.showSearchBoardList = false;
             this.boardSearchKeyword = '';
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = message;
             this.hideSuccesfullFunctionErrorDelete();
           })
         })
       });
     }

     onSearchBoards() {
       this.searchBoards(this.boardSearchKeyword);
     }

     searchBoards(searchText: string = ""){
       this.downloadDelete = false;
       this.changeColor = [];
       this.imageSelected = false;
       this.damService.searchBoards(this.workspaceId, searchText).subscribe((data: any) => {
         this.searchedBoards = data;
         this.showSearchBoardOlderList = false;
         this.showSearchBoardList = true;
         this.boardSearchKeyword = '';
       },(error) => {
         this.closeMoveImagesStyleBoard();
         const errors = error.error || error.statusText;
         Object.keys(errors).map((key) => {
           errors[key].map((message) => {
             this.boardSearchKeyword = '';
             this.showSearchBoardOlderList = true;
             this.showSearchBoardList = false;
             this.sendSuccessfulErrorMsg = true;
             this.sendSuccessfulErrorMessage = message;
             this.hideSuccesfullFunctionErrorDelete();
           })
         })
       });
     }

     allowDownload() {
       if(this.allowDownloadSelected) {
         this.allowDownloadSelected = false;
       } else {
         this.allowDownloadSelected = true;
       }
     }

     allowShowComments() {

     }

     allowCommenting() {

     }

     selectExpireLink (event: any) {
       this.expiryLinkIn = event.target.value;
     }

     openAssetRenameDialog(assetId: any, currentName: any, boardId: any, imageLink: any) {
       this.renameImageLink = imageLink;
       this.renameErrorMsg = "";
       this.assetCurrentId = assetId;
       this.assetCurrentName = currentName;
       this.renameBoardId = boardId;
       this.assetRenameStyle = "block";
     }

     closeAssetRenameDialog() {
       this.renameErrorMsg = "";
       this.assetRenameStyle = "none";
     }

     assetRename() {
       this.renameErrorMsg = "";
       this.showRenameLoader = true;
       this.damService.changeImageNameApi(this.workspaceId, this.renameBoardId, this.assetCurrentId, this.assetNewName).subscribe((data: any) => {
         this.renameImageLink = "";
         this.assetRenameStyle = "none";
         this.showRenameLoader = false;
         this.sendSuccessful = true;
         this.successfullMessage = "Renamed " + this.assetCurrentName + " to " +this.assetNewName;
         this.hideSuccesfullFunction();
         this.searchArrayImages(this.searchText, this.searchTerms);
       },
       (error: any) => {
         if(error.status == 403 || error.status == 400){
           this.showRenameLoader = false;
           this.renameErrorMsg = error.error.message;
         } else {
           this.showRenameLoader = false;
           this.renameErrorMsg = error.error.message;
         }
      });
     }

     openEditTagsDialog(assetId: any, currentName: any, imageLink: any, boardId: any, imgFormat: any) {
       this.editTagsImageLink = imageLink;
       this.editTagsImageFormats = imgFormat;
       this.editTagsError = "";
       this.assetCurrentId = assetId;
       this.assetCurrentName = currentName;
       this.assetBoardId = boardId;
       this.assetEditTagsStyle = "block";
     }

     closeEditTagsDialog() {
       this.assetEditTagsStyle = "none";
     }

     onSubmitMultipleTags() {
       if(this.tagsForm.valid) {
         this.editTagsList.push(this.tagsForm.value['edittags']);
         this.tagsForm.reset();
       }
     }

     removeAddedTags(index: number) {
       this.editTagsList.splice(index, 1);
     }

     editMultipleTags() {
       this.editTagsError = "";
       if (this.editTagsList.length === 0) {
         this.editTagsError = "Add a tag and press Enter.";
       } else {
         this.showEditTagsLoader = true;
         this.damService.addMultipleImageTags(this.workspaceId, this.assetBoardId, this.assetCurrentId,
           this.editTagsList.join(', ')).subscribe((data: any) => {
             this.editTagsList = [];
             this.showEditTagsLoader = false;
             this.assetEditTagsStyle = "none";
             this.editTagsImageLink = "";
             this.sendSuccessful = true;
             this.successfullMessage = "Tags added successfully!!"
             this.searchArrayImages(this.searchText, this.searchTerms);
             this.hideSuccesfullFunction();
         },
         (error: any) => {
           if(error.status == 403 || error.status == 400){
             this.showEditTagsLoader = false;
             this.editTagsError = error.error.message;
           } else {
             this.showEditTagsLoader = false;
             this.editTagsError = error.error.message;
           }
         });
       }
     }

     restoreAssets(boardId: any, imgId: any) {
       this.damService.restoreAssets(this.workspaceId, boardId, imgId).subscribe((data: any) => {
         this.searchArrayImages(this.searchText, this.searchTerms);
         this.sendSuccessful = true;
         this.successfullMessage = data.message;
         this.hideSuccesfullFunction();
       });
     }

     openEditBoardNames(boardId: any, boardTitle: any) {
       this.renameErrorMsg = "";
       this.boardCurrentName = boardTitle;
       this.editNameBoardId = boardId;
       this.boardNewName = boardTitle;
       this.boardRenameStyle = "block";
     }

     closeEditBoardNames() {
       this.renameErrorMsg = "";
       this.boardRenameStyle = "none";
     }

     editBoardNamesApi(){
       this.renameErrorMsg = "";
       this.showRenameLoader = true;
       this.damService.editBoardName(this.workspaceId, this.editNameBoardId, this.boardNewName).subscribe((data: any) => {
         this.boardHeading = data.title;
         this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
           this.boardRenameStyle = "none";
           this.showRenameLoader = false;
           this.boards = data;
           this.sendSuccessful = true;
           this.successfullMessage = "Renamed " + this.boardCurrentName + " to " +this.boardNewName;
           this.hideSuccesfullFunction();
         });
       },(error: any) => {
         if(error.status == 400){
           this.showRenameLoader = false;
           this.renameErrorMsg = error.error.message;
         } else {
           this.showRenameLoader = false;
           this.renameErrorMsg = error.error.message;
         }
      });
     }

     goToLibrary() {
       this.googleAnalyticsService.event('library_click_settings_screen_click', 'library_click', this.currentUser.firstName +" "+this.currentUser.lastName);
       this.router.navigate(['/library']);
     }

     createWorkspace(workspaceName: any){
       if (this.currentUser) {
         if(this.creatwWorkspace.valid) {
           this.showLeaveLoader = true;
           this.isShowCreateWorkspaceError = false
           this.organisationService.createNewWorkspace(workspaceName).subscribe((data: any) => {
             this.showLeaveLoader = false;
             this.creatwWorkspace.reset();
             localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data.id,
               workspaceName: data.title, userRole: data.role }));
             this.router.navigate(['/dam']);
             this.closeNewWorkspaceDialog();
           },
           (error) => {
             if(error.status == 403){
               this.showLeaveLoader = false;
               this.isShowCreateWorkspaceError = true
               this.createWorkspaceErrorMessage = error.error.Message;
             } else {
               this.showLeaveLoader = false;
               this.isShowCreateWorkspaceError = true
               this.createWorkspaceErrorMessage = error.error.Message;
             }
          });
         }
       }else{
         this.isShowCreateLoginWorkspaceError = true
         this.createWorkspaceLoginErrorMessage = "Login to Continue";
       }
     }

     openNewWorkspaceDialog() {
       this.createWorkspaceStyle = "block";
     }

     closeNewWorkspaceDialog() {
       this.createWorkspaceStyle = "none";
     }

     showSettingsCouponTab() {
       this.googleAnalyticsService.event('coupon_tab_settings_screen_click', 'coupon_tab_click', this.currentUser.firstName +" "+this.currentUser.lastName);
       this.showCouponTab = true;
     }

     getSuggestedTags(boardId: any, imgId: any){
       this.damService.listGetSuggestedTags(this.workspaceId, boardId, imgId).subscribe((data: any) => {
         this.suggestedTags = data.labels;
       },
       (error) => {
         if(error.status == 400){

         } else {

         }
       });
     }

     editImageNameBoardId: any;

     editImageName(boardId: any){
       this.renameErrorMsg = "";
       this.imageNameEdit = this.imageHeading;
       this.editImageNameBoardId = boardId;
       this.showEditImageName = true;
       this.hideEditImageName = false;
       this.showEditFavImageName = false;
       this.hideEditFavImageName = false;
     }

     closeImageEditField(){
       this.renameErrorMsg = "";
       this.favImageNameEdit = "";
       this.imageNameEdit = "";
       this.editImageNameBoardId = '';
       this.editImageNameBoardId = '';
       this.showEditImageName = false;
       this.hideEditImageName = true;
       this.showEditFavImageName = false;
       this.hideEditFavImageName = true;
     }

     editImageNameApi(imgId: any, imgFrom: any){
       this.damService.changeImageNameApi(this.workspaceId, this.editImageNameBoardId, imgId, this.imageNameEdit).subscribe((data: any) => {
         this.showEditImageName = false;
         this.hideEditImageName = true;
         this.imageHeading = data.title;
         this.renameErrorMsg = "";
         this.showEditFavImageName = false;
         this.hideEditFavImageName = true;
         this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
           this.searchText = "";
           this.imagesList = data.image;
           this.searchData = '' + this.searchTextSet;
           this.settingsSection = false;
           this.searchImageslistSection = true;
           for(var i = 0 ; i < this.imagesList.length ; i++) {
             this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
           }
         });

         this.editImageNameBoardId = "";
       },
       (error: any) => {
         if(error.status == 403){
           this.renameErrorMsg = error.error.message;
         } else {
           this.renameErrorMsg = error.error.message;
         }
      });
     }


     editFavImageName(boardId: any){
       this.renameErrorMsg = "";
       this.favImageNameEdit = this.favImageHeading;
       this.editImageNameBoardId = boardId;
       this.showEditFavImageName = true;
       this.hideEditFavImageName = false;
       this.showEditImageName = false;
       this.hideEditImageName = false;
     }

     editFavImageNameApi(imgId: any, imgFrom: any){
       this.damService.changeImageNameApi(this.workspaceId, this.editImageNameBoardId, imgId, this.favImageNameEdit).subscribe((data: any) => {
         this.showEditFavImageName = false;
         this.hideEditFavImageName = true;
         this.favImageHeading = data.title;
         this.renameErrorMsg = "";
         this.showEditImageName = false;
         this.hideEditImageName = true;
         this.damService.searchImagesArray(this.workspaceId, this.searchTerms).subscribe((data: any) => {
           this.searchText = "";
           this.imagesList = data.image;
           this.searchData = '' + this.searchTextSet;
           this.settingsSection = false;
           this.searchImageslistSection = true;
           for(var i = 0 ; i < this.imagesList.length ; i++) {
             this.currentIllus = this.imagesList[this.currentSearchIllusPosition];
           }
         });
         this.editImageNameBoardId = "";
       },
       (error: any) => {
         if(error.status == 403){
           this.renameErrorMsg = error.error.message;
         } else {
           this.renameErrorMsg = error.error.message;
         }
      });
     }

     goProClick() {
       this.router.navigate(['/dam/subscription']);
     }

     favouriteImagesList = [];

     getFavImagesList() {
       this.damService.listFavouriteImages(this.workspaceId).subscribe((data: any) => {
         this.favouriteImagesList = data['results'];
       });
     }
   }
